<template>
    <v-model.login.verify v-slot="{ model, loading, isError, canSubmit, toggleRecoveryCode, sendEmailCode }">
        <div class="hgroup">
            <h1 class="card-title">Weryfikacja dwuetapowa</h1>
            <span class="card-subtitle">{{ subtitle }}</span>
        </div>

        <div v-if="isError && !loading" class="alert alert-danger vert-middle" role="alert">
            <v-icon icon="close-fill fs-4"/> {{ $auth.flow.useRecoveryCode ? 'Nieprawidłowy kod odzyskiwania' : 'Nieprawidłowy kod weryfikacyjny' }}
        </div>

        <div v-if="$auth.flow.recoveryCode" class="alert alert-warning" role="alert">
            Zapisz kod odzyskiwania w bezpiecznym miejscu: <strong>{{ $auth.flow.recoveryCode }}</strong>
        </div>

        <template v-if="$auth.flow.useRecoveryCode">
            <v-control-input v-model="model.code" label="Kod odzyskiwania" placeholder="XXXXX-XXXXX" :slim="true"/>
            <p class="small text-muted mt-2 mb-3">
                Kod odzyskiwania otrzymałeś przy konfiguracji weryfikacji dwuetapowej. Po jego użyciu skonfigurujesz weryfikację od nowa.
            </p>
        </template>
        <template v-else>
            <v-control-code v-model="model.code" label="Kod weryfikacyjny" :autofocus="true"/>
            <div v-if="emailCode" class="mb-3">
                <v-button color="link" class="p-0" icon="mail-send-line-1" :label="resendLabel"
                          :disabled="resendWaitSeconds > 0" @click="sendEmailCode"/>
            </div>
        </template>

        <v-button :loading="loading" :submit="true" class="w-100" color="primary" label="Weryfikuj"
                  :disabled="!canSubmit() || loading"/>

        <v-button color="link" class="w-100 mt-2"
                  :label="$auth.flow.useRecoveryCode ? 'Użyj kodu weryfikacyjnego' : 'Nie masz dostępu do aplikacji? Użyj kodu odzyskiwania'"
                  @click="toggleRecoveryCode"/>

        <v-button class="w-100 mt-2" color="secondary" :outline="true" icon="arrow-left-s" label="Wróć do logowania"
                  @click="$auth.cancelLogin()"/>
    </v-model.login.verify>
</template>

<script>
import {EMAIL_CODE_RESEND_COOLDOWN_MS} from "@/services/vault";

export default {
    name: "v-auth-two-factor-verify",
    data() {
        return {
            now: Date.now(),
            ticker: null
        }
    },
    mounted() {
        this.ticker = setInterval(() => {
            this.now = Date.now();
        }, 1000);
    },
    unmounted() {
        clearInterval(this.ticker);
    },
    computed: {
        emailCode() {
            return this.$auth.flow.codeType === 'email';
        },
        subtitle() {
            if (this.$auth.flow.useRecoveryCode)
                return 'Wpisz kod odzyskiwania w formacie XXXXX-XXXXX';

            return this.emailCode
                ? 'Kod weryfikacyjny został wysłany na Twój adres email'
                : 'Wpisz 6-cyfrowy kod z aplikacji Google Authenticator';
        },
        resendWaitSeconds() {
            const sentAt = this.$auth.flow.emailCodeSentAt;

            return sentAt ? Math.max(0, Math.ceil((sentAt + EMAIL_CODE_RESEND_COOLDOWN_MS - this.now) / 1000)) : 0;
        },
        resendLabel() {
            return 'Wyślij kod ponownie' + (this.resendWaitSeconds ? ` (${this.resendWaitSeconds} s)` : '');
        }
    }
}
</script>
